import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import VideosCarousel from '../../VideosCarousel';
import CarouselDataProvider from '../components/CarouselDataProvider';
import './CarouselWrapper.scss';

const CarouselWrapper = (props) => {
  const {
    useFilterableResources,
    resourceId,
    allAvailableVideoResources,
    viewVideo,
    studentClasses,
    isStudent,
    isTeacher,
    subject,
    filteredResources,
    hasFilteredResources,
    loadingFilteredResources,
    router,
    filteredResourcesLabel,
    filteredClasses,
    apdCarouselData,
  } = props;

  return (
    (useFilterableResources && (
      <CarouselDataProvider
        router={router}
        resourceId={resourceId}
        loadingFilteredResources={loadingFilteredResources}
        hasFilteredResources={hasFilteredResources}
        allResources={allAvailableVideoResources}
        filteredResources={filteredResources}
        filteredResourcesLabel={filteredResourcesLabel}
        render={({
          activeResourceId,
          items,
          navigationComponent,
          activeLink,
        }) => {
          if (!(items || []).length || !activeResourceId) return null;

          return (
            <Fragment>
              {navigationComponent}
              <VideosCarousel
                key={activeLink}
                activeResourceId={activeResourceId}
                items={items}
                onVideoChange={viewVideo}
                studentClasses={studentClasses}
                isStudent={isStudent}
                isTeacher={isTeacher}
                subjectId={subject.id}
                apdCarouselData={apdCarouselData}
                filteredClasses={filteredClasses}
              />
            </Fragment>
          );
        }}
      />
    )) || (
      <VideosCarousel
        activeResourceId={resourceId}
        items={allAvailableVideoResources}
        onVideoChange={viewVideo}
        studentClasses={studentClasses}
        isStudent={isStudent}
        isTeacher={isTeacher}
        subjectId={subject.id}
        apdCarouselData={apdCarouselData}
        filteredClasses={filteredClasses}
      />
    )
  );
};

CarouselWrapper.propTypes = {
  apOutlineSearchFlag: PropTypes.bool,
  resourceId: PropTypes.string.isRequired,
  allAvailableVideoResources: PropTypes.array.isRequired,
  viewVideo: PropTypes.func,
  studentClasses: PropTypes.array.isRequired,
  isStudent: PropTypes.bool.isRequired,
  isTeacher: PropTypes.bool.isRequired,
  subject: PropTypes.object.isRequired,
  hasFilteredResources: PropTypes.bool,
  loadingFilteredResources: PropTypes.bool,
  router: PropTypes.object.isRequired,
  apdCarouselData: PropTypes.object.isRequired,
  filteredResourcesLabel: PropTypes.string.isRequired,
  filteredClasses: PropTypes.array,
};

CarouselWrapper.defaultProps = {
  apOutlineSearchFlag: false,
  viewVideo: () => {},
  hasFilteredResources: false,
  loadingFilteredResources: false,
  filteredClasses: [],
};

export default CarouselWrapper;
